import type { SVGProps } from 'react';
const SvgFacebookCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={26} height={26} {...props}>
    <path
      fill="#1A202C"
      d="M24 13c0-6.077-4.923-11-11-11S2 6.923 2 13c0 5.49 4.023 10.041 9.281 10.867V16.18H8.487V13h2.794v-2.424c0-2.756 1.641-4.279 4.155-4.279 1.204 0 2.463.215 2.463.215v2.705H16.51c-1.366 0-1.792.848-1.792 1.718V13h3.05l-.487 3.18h-2.563v7.687C19.977 23.04 24 18.49 24 13"
    />
  </svg>
);
export default SvgFacebookCircle;
